import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useParams, useRouteMatch, Link, useHistory} from 'react-router-dom'

function MuseumEditDetail(){
    const [museum, setMuseum] = useState();
    let {id} = useParams();

    useEffect(()=>{
        getMuseum()
    }, [id])

    const history = useHistory();


    function getMuseum(){
        axios.get(`/api/get_museum/${id}`)
        .then(museumDataFromMongo=>{
            setMuseum(museumDataFromMongo.data)
        })
        .catch(error=>{
            console.log(error)
        })
    }

    function removeMuseum(){
        axios.get(`/api/museum_remove/${id}`)
        .then(()=>{
            history.push('/admin/private/museum-list');
        })
        .catch(err=>{
            console.log(err)
        })
    }

    return(
        <div className='detail'>
            {(museum)?<div>
            <h2>{museum.name}</h2>
            <div className='detail-flex'>
            <p className='detail-left'>Address</p>
            <div className='address-wrapper'>
            <p id='detail-address1'>{museum.address1}</p>
            <p id='detail-address2'>{museum.address2}</p>
            </div>
            </div>
            <div className='detail-flex'>
            <p className='detail-left'>Opening Hours</p>
            <p className='detail-right'>{museum.opening_hours}</p>
            </div>
            <div className='detail-flex'>
            <p className='detail-left'>Closing Days</p>
            <p className='detail-right'>{museum.closing_days}</p>
            </div>
            <div className='detail-flex'>
            <p className='detail-left'>Tickets</p>
            <p className='detail-right'>{museum.tickets}</p>
            </div>
            <div className='detail-flex'>
            <p className='detail-left'>Web-Site</p>
            <p className='detail-right'><a href={museum.website}>{museum.name}</a></p>
            </div>

            <div className='edit_remove_flex'>
            <div><p onClick={removeMuseum} className='remove_button'>remove</p></div>
            <Link to={`/admin/private/museum-list/edit/${museum._id}`} className='edit_button_wrapper'><p className='edit_button'>Edit</p></Link>
            </div>
            </div>:''}
        </div>
    )
};

export default MuseumEditDetail;